/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  selectedPlanType: '',
  rebateProgram: [],
  errorMsgRates: [],
  rebateProgramName: {},
  startQtr: '',
  isAllManufacturersSelected: true,
  manufacturerList: [],
  suppleRates: {},
  selectRowIndex: null,
  manuRates: [],
  displayObj: {
    rebateProgramName: {},
    startQtr: '',
    suppleRates: {},
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_RATES:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_RATES:
      return { ...state, errorMsgRates: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_RATES:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_RATES:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_RATES:
      return { ...state, startQtr: action.payload };
    case actionTypes.MANUFACTURER_GRID_RATES:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.GET_REBATE_PROGRAM_NAME_RATES:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SET_SUPPLEMENTAL_RATES:
      let displayObj = {
        ...state.displayObj,
        suppleRates: action.payload,
      };
      return { ...state, suppleRates: action.payload, displayObj };
    // return { ...state, suppleRates: action.payload };

    case actionTypes.SET_MANUFACTURER_RATES:
      return { ...state, ...action.payload };
    case actionTypes.SET_DISPLAY_OBJ_PRO:
      // let tempObj = {
      //   ...state.displayObj,
      //   rebateProgramName: {
      //     ...action.payload.rebateProgramName,
      //   },
      // };

      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_REFRESH_DATA_RATES:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        selectedPlanType: '',
        rebateProgram: [],
        errorMsgRates: [],
        rebateProgramName: {},
        startQtr: '',
        isAllManufacturersSelected: true,
        manufacturerList: [],
        selectRowIndex: null,
        manuRates: [],
      };
    case actionTypes.SET_REFRESH_DATA_RATES_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
